import { useMutation } from 'react-query';

import {
  confirmCheckoutSession,
  startCheckoutSession,
  startUnauthenticatedCheckoutSession,
  updateCheckoutSession,
  updateUnauthenticatedCheckoutSession
} from 'api/services/events/checkout';
import { OutgoingCheckoutSessionDto } from 'api/dtos/events/checkout';
import {
  UpdateCheckoutSessionParams,
  UpdateUnauthenticatedCheckoutSessionParams,
  ConfirmCheckoutSessionParams
} from 'api/types/events/checkout';
import { ErrorResponse } from 'api/types/errors';

/**
 * Starts a multi-tier checkout session
 */
export function useStartMultiTierCheckoutSession() {
  return useMutation<OutgoingCheckoutSessionDto, ErrorResponse, string>(
    startCheckoutSession
  );
}

/**
 * Starts an unauthenticated multi-tier checkout session
 */
export function useStartUnauthenticatedMultiTierCheckoutSession() {
  return useMutation<OutgoingCheckoutSessionDto, ErrorResponse, string>(
    startUnauthenticatedCheckoutSession
  );
}

/**
 * Updates a multi-tier checkout session
 */
export function useUpdateMultiTierCheckoutSession() {
  return useMutation<
    OutgoingCheckoutSessionDto,
    ErrorResponse,
    UpdateCheckoutSessionParams
  >(updateCheckoutSession);
}

/**
 * Updates an unauthenticated multi-tier checkout session
 */
export function useUpdateUnauthenticatedMultiTierCheckoutSession() {
  return useMutation<
    OutgoingCheckoutSessionDto,
    ErrorResponse,
    UpdateUnauthenticatedCheckoutSessionParams
  >(updateUnauthenticatedCheckoutSession);
}

/**
 * Confirms a multi-tier checkout session
 */
export function useConfirmMultiTierCheckoutSession() {
  return useMutation<void, ErrorResponse, ConfirmCheckoutSessionParams>(
    confirmCheckoutSession
  );
}
